import { useEffect, type PropsWithChildren } from 'react'
import { useSession } from 'next-auth/react'

import { Logo } from '@themenu/design-system'

import { setToken } from 'lib/services/auth'

import { BackButton } from './components/BackButton'
import { ContentWrapper } from './components/ContentWrapper'
import { HeroImage } from './components/HeroImage'
import { Footer } from './components/Footer'
import { SwileCardImage } from './components/SwileCardImage'

export const Layout = ({ children }: PropsWithChildren) => {
  const { data, status } = useSession()

  useEffect(() => {
    if (status === 'authenticated' && data?.user?.token) {
      setToken(data.user.token)
    }
  }, [status, data?.user?.token])

  return (
    <section className="grid grid-cols-1 min-h-screen md:grid-cols-[6.5fr_5.5fr]">
      <div className="flex flex-col gap-32 p-24">
        <BackButton />

        <div className="flex flex-1 items-center gap-48">
          <SwileCardImage />
          <ContentWrapper>{children}</ContentWrapper>
        </div>

        <Footer />
      </div>

      <div className="hidden md:block">
        <HeroImage />
        <Logo height={20} inverted className="absolute top-32 right-32" />
      </div>
    </section>
  )
}
